// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	FeeSubjectToHstCheckbox: 'fee-subject-to-hst-checkbox',
	FeeAmountInput: 'fee-amount-input',
	TitleSection: 'title-section',
	SignItButton: 'sign-it-button',
	SignItNote: 'sign-it-note',
	Note: 'note',
} as const;
